import React from "react";
import TextInput from "../inputs/text-input";
import CheckBoxInput from "../inputs/checkbox-input";
import SelectFieldComboField from "../inputs/select-field-combo/select-field-combo-field";
import { PROVINCES } from "application/constants/app-constants";
import getCountry from "module/functions/getCountry";

const UserAddress = (props) => {
  const { form, register, errors, display, setOnFocus, setSelectValue } = props;
  const country = getCountry();
  const isFrance = country === "fr";

  return (
    <div className="form__form-wrapper-user">
      <div className="form__form-body" style={{ display: display ? "block" : "none" }}>
        <div className="field-creator__field-container-group">
          <TextInput
            path={"address.value"}
            name={`${form.address.name}`}
            register={register}
            errors={errors}
            users
            setOnFocus={setOnFocus}
          />
          <TextInput
            path={"floor.value"}
            name={form.floor.name}
            register={register}
            errors={errors}
            users
            setOnFocus={setOnFocus}
          />
          <div style={{ display: "none" }}>
            <TextInput
              path={"region.value"}
              name={form.region.name}
              register={register}
              errors={errors}
              users
              setOnFocus={setOnFocus}
            />
          </div>
          {country === "fr" && (
            <>
              <TextInput
                path={"digicode.value"}
                name={form.digicode.name}
                register={register}
                errors={errors}
                users
                setOnFocus={setOnFocus}
              />
            </>
          )}
          <TextInput
            path={"postal_code.value"}
            name={`${form.postal_code.name}`}
            register={register}
            errors={errors}
            users
            setOnFocus={setOnFocus}
          />
          {country === "fr" && (
            <>
              <div className="field-creator__field-container field-creator__field-container-users">
                <SelectFieldComboField
                  name={`${form.province.name}`}
                  path={"province_fake"}
                  register={register}
                  selOptions={PROVINCES ?? []}
                  errors={errors}
                  setOnFocus={setOnFocus}
                  setSelectValue={setSelectValue}
                  hasSearch={true}
                />
              </div>
              <div style={{ display: "none" }}>
                <TextInput
                  path={"province_code.value"}
                  name={form.province_code.name}
                  register={register}
                  errors={errors}
                  users
                  setOnFocus={setOnFocus}
                />
                <TextInput
                  path={"province.value"}
                  name={form.province.name}
                  register={register}
                  errors={errors}
                  users
                  setOnFocus={setOnFocus}
                />
              </div>
            </>
          )}
          <TextInput
            path={"city.value"}
            name={form.city.name}
            register={register}
            errors={errors}
            users
            setOnFocus={setOnFocus}
          />
          {isFrance && (
            <div className="accept_service">
              <CheckBoxInput name={`${form.accept_service.name}`} path={"service"} register={register} />
            </div>
          )}
          <CheckBoxInput name={`${form.accept_terms.name}`} path={"accept"} register={register} />
        </div>
      </div>
    </div>
  );
};

export default UserAddress;
